import React, { ReactNode } from "react"
import { Drawer, IconButton } from "material-ui"
import CloseIcon from "material-ui/svg-icons/navigation/close"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    title: string
    open: boolean
    children: ReactNode
    handleClose(): void
}

const FinddWideDrawer: React.SFC<IProps> = (props: IProps) => {
    return (
        <Drawer
            open={props.open}
            width={AppStateStore.getContentWidth()}
            openSecondary
            docked={false}
            overlayStyle={{ zIndex: 1500 }}
            containerStyle={{ zIndex: 1500, overflow: "unset" }}
            onRequestChange={props.handleClose}
        >
            {props.open &&
                <div>
                    <div style={{ backgroundColor: AppStateStore.getDrawerHeaderColor(), height: 100, position: "relative", textAlign: "center" }}>
                        <div style={{ color: "white", fontSize: 25, fontWeight: 400, paddingTop: 40 }}>
                            {props.title}
                        </div>
                        <IconButton
                            style={{ cursor: "pointer", position: "absolute", top: 27, right: 20 }}
                            onClick={props.handleClose}
                        >
                            <CloseIcon color={"white"} />
                        </IconButton>
                    </div>
                    <div style={{ padding: 25, overflow: "auto", height: "calc(100vh - 100px)" }}>
                        {props.children}
                    </div>
                </div>
            }
        </Drawer>
    )
}

export default FinddWideDrawer
